'use client';

import { c as _c } from "react/compiler-runtime";
import icon from '@images/renders/architecture_images/icons/plus.svg';
import cn from 'classnames';
import NextImage from 'next/image';
import { useEffect, useState } from 'react';
import style from './ImageWrapperMob.module.scss';
function ImageWrapperMob(t0) {
  const $ = _c(15);
  const {
    children,
    className
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (open) {
        document.body.classList.add(style.scrollDisabled);
      }
      if (open === false) {
        document.body.classList.remove(style.scrollDisabled);
      }
    };
    t2 = [open, setOpen];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== className) {
    t4 = cn(style.icon, className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <button onClick={t3} className={style.imgButton}><NextImage className={t4} src={icon} alt="plus" /></button>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== open) {
    t6 = open && <div className={style.modal} onClick={() => setOpen(false)} role="button" tabIndex="0">{children}</div>;
    $[8] = children;
    $[9] = open;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t5 || $[13] !== t6) {
    t7 = <>{children}{t5}{t6}</>;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
export default ImageWrapperMob;